import { post } from './utils';

export const confirmPickApi = ({ id }) => {
  return post(`/transfer-orders/${id}/confirm-pick`);
};

export const rejectTransferOrdersApi = ({ id, data }) =>
  post(`/transfer-orders/${id}/reject`, data);

export const cancelTransferOrdersApi = ({ id }) =>
  post(`/transfer-orders/${id}/cancel`);

export const receivedTransferOrdersApi = ({ id }) =>
  post(`/transfer-orders-batch/${id}/received`);
